import { render } from "./layout-horizontal.vue?vue&type=template&id=e0c65684"
import script from "./layout-horizontal.vue?vue&type=script&lang=js"
export * from "./layout-horizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__